{
  "version": 1,
  "campaignId": "serpent-born-wild",
  "title": "Serpent: Born Wild",
  "initialMissionId": "hatch-or-die",
  "modes": ["campaign", "simulation"],
  "tendencyKeys": [
    "guardian",
    "dominance",
    "mutation",
    "chaos",
    "coexistence"
  ],
  "chapterCatalog": [
    { "order": 1, "id": "hatch-or-die", "title": "Hatch or Die", "implementation": "vertical-slice" },
    { "order": 2, "id": "small-teeth", "title": "Small Teeth", "implementation": "vertical-slice" },
    { "order": 3, "id": "nest-butcher", "title": "The Nest Butcher", "implementation": "vertical-slice" },
    { "order": 4, "id": "green-current", "title": "The Green Current", "implementation": "planned" },
    { "order": 5, "id": "concrete-jungle", "title": "Concrete Jungle", "implementation": "planned" },
    { "order": 6, "id": "broken-balance", "title": "The Broken Balance", "implementation": "planned" },
    { "order": 7, "id": "mountain-road", "title": "The Mountain Road", "implementation": "planned" },
    { "order": 8, "id": "beneath-the-stone", "title": "Beneath the Stone", "implementation": "planned" },
    { "order": 9, "id": "weight-of-water", "title": "The Weight of Water", "implementation": "planned" },
    { "order": 10, "id": "flood-below", "title": "The Flood Below", "implementation": "planned" },
    { "order": 11, "id": "bloodline-project", "title": "Bloodline Project", "implementation": "planned" },
    { "order": 12, "id": "dry-expanse", "title": "The Dry Expanse", "implementation": "planned" },
    { "order": 13, "id": "last-current", "title": "The Last Current", "implementation": "planned" },
    { "order": 14, "id": "born-wild", "title": "Born Wild", "implementation": "planned" },
    { "order": 15, "id": "after-the-coil", "title": "After the Coil", "implementation": "planned" }
  ],
  "eventRules": [
    {
      "id": "discover-sibling-scent",
      "eventType": "interaction",
      "targetId": "sibling-scent",
      "effects": {
        "flags": { "siblingEvidenceFound": true },
        "rival": { "respect": 1 }
      }
    }
  ],
  "missions": [
    {
      "id": "hatch-or-die",
      "chapter": 1,
      "title": "Hatch or Die",
      "description": "Break free, survive the opening predator, and reach cover.",
      "prerequisites": { "missions": [], "flags": [] },
      "objectives": [
        {
          "id": "hatch",
          "type": "interaction",
          "targetId": "egg-shell",
          "required": 1,
          "label": "Break out of the egg"
        },
        {
          "id": "survive-opening-attack",
          "type": "survival-time",
          "required": 5,
          "label": "Survive the opening attack"
        },
        {
          "id": "reach-first-cover",
          "type": "location-entry",
          "targetId": "safe-cover",
          "required": 1,
          "label": "Reach the first hiding place"
        }
      ],
      "completionEffects": {
        "flags": {
          "hatched": true,
          "firstShelterReached": true
        }
      },
      "nextMissionId": "small-teeth",
      "autoStartNext": true
    },
    {
      "id": "small-teeth",
      "chapter": 2,
      "title": "Small Teeth",
      "description": "Track prey, make the first kill, eat, grow, and choose an early adaptation.",
      "prerequisites": { "missions": ["hatch-or-die"], "flags": ["hatched"] },
      "objectives": [
        {
          "id": "first-hunt",
          "type": "hunt",
          "required": 1,
          "label": "Complete the first hunt"
        },
        {
          "id": "first-meal",
          "type": "eat",
          "required": 1,
          "label": "Eat the first prey"
        },
        {
          "id": "first-growth",
          "type": "growth",
          "required": 0.25,
          "label": "Gain the first growth points"
        },
        {
          "id": "first-evolution",
          "type": "interaction",
          "targetId": "choice:first-evolution",
          "required": 1,
          "label": "Choose the first evolution path"
        }
      ],
      "choices": [
        {
          "id": "first-evolution",
          "label": "First Evolution",
          "options": [
            {
              "id": "ambush",
              "label": "Ambush",
              "effects": { "flags": { "evolutionPath": "ambush" } }
            },
            {
              "id": "pursuit",
              "label": "Pursuit",
              "effects": { "flags": { "evolutionPath": "pursuit" } }
            },
            {
              "id": "aquatic",
              "label": "Aquatic",
              "effects": { "flags": { "evolutionPath": "aquatic" } }
            },
            {
              "id": "climber",
              "label": "Climber",
              "effects": { "flags": { "evolutionPath": "climber" } }
            }
          ]
        }
      ],
      "completionEffects": {
        "flags": { "firstGrowthStageReached": true }
      },
      "nextMissionId": "nest-butcher",
      "autoStartNext": true
    },
    {
      "id": "nest-butcher",
      "chapter": 3,
      "title": "The Nest Butcher",
      "description": "Confront the opening predator through stealth, timing, and environmental advantage.",
      "prerequisites": { "missions": ["small-teeth"], "flags": ["firstGrowthStageReached"] },
      "objectives": [
        {
          "id": "survive-boss-search",
          "type": "survival-time",
          "required": 10,
          "label": "Survive the predator search"
        },
        {
          "id": "defeat-or-drive-off-heron",
          "type": "hunt",
          "targetId": "great-blue-heron",
          "required": 1,
          "label": "Defeat or force out the opening predator"
        },
        {
          "id": "resolve-boss-fate",
          "type": "interaction",
          "targetId": "choice:nest-butcher-resolution",
          "required": 1,
          "label": "Determine the predator's fate"
        },
        {
          "id": "enter-open-swamp",
          "type": "interaction",
          "targetId": "open-swamp",
          "required": 1,
          "label": "Enter the open swamp"
        }
      ],
      "choices": [
        {
          "id": "nest-butcher-resolution",
          "label": "The Nest Butcher's Fate",
          "options": [
            {
              "id": "kill",
              "label": "Kill it",
              "effects": {
                "tendencies": { "dominance": 10 },
                "rival": { "fear": 5, "respect": 2 },
                "flags": { "nestButcherOutcome": "killed" }
              }
            },
            {
              "id": "drive-away",
              "label": "Drive it away",
              "effects": {
                "tendencies": { "guardian": 5, "coexistence": 5 },
                "rival": { "respect": 5 },
                "flags": { "nestButcherOutcome": "driven-away" }
              }
            },
            {
              "id": "steal-and-escape",
              "label": "Steal food and escape",
              "effects": {
                "tendencies": { "coexistence": 3, "chaos": 2 },
                "rival": { "respect": 1 },
                "flags": { "nestButcherOutcome": "escaped" }
              }
            }
          ]
        }
      ],
      "completionEffects": {
        "flags": {
          "openSwampUnlocked": true,
          "verticalSliceComplete": true
        }
      },
      "nextMissionId": null,
      "autoStartNext": false
    }
  ]
}
